"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const epic_alt_utils_1 = require("epic-alt-utils");
const PsnContryRegionMapping_1 = __importDefault(require("../constants/PsnContryRegionMapping"));
const seamless_immutable_1 = __importDefault(require("seamless-immutable"));
const PosaRedeemActions_1 = __importDefault(require("../actions/PosaRedeemActions"));
const PosaRedeemSource_1 = __importDefault(require("../sources/PosaRedeemSource"));
const epic_react_common_1 = require("epic-react-common");
const decorators_1 = require("alt-utils/lib/decorators");
const epic_tracking_1 = __importDefault(require("epic-tracking"));
const index_1 = require("../utils/index");
let PosaRedeemStore = class PosaRedeemStore {
    constructor() {
        this.on('error', error => {
            console.error(error);
        });
        this.on('bootstrap', epic_alt_utils_1.seamlessBootstrap.bind(this, null));
        this.state = seamless_immutable_1.default({
            loading: false,
            page: null,
            error: false,
            errorCode: null,
            code: null,
            codeVerified: false,
            verifying: false,
            platform: null,
            psnCountry: null,
            psnRegion: null,
            showConfirm: false,
            epicAccountName: null,
            redeemed: false,
            secondaryCode: {}
        });
        this.bindActions(PosaRedeemActions_1.default);
    }
    trackEvent(action, data = {}) {
        const { platform, psnCountry, psnRegion } = this.state;
        const track = {
            interactionType: 'api',
            eventCategory: 'PosaRedeem',
            eventAction: action
        };
        if (platform)
            track.platform = platform;
        if (psnCountry)
            track.psnCountry = psnCountry;
        if (psnRegion)
            track.psnRegion = psnRegion;
        epic_tracking_1.default.trackEvent('Interaction', Object.assign(Object.assign({}, track), data));
    }
    onTrack(args) {
        this.trackEvent(...args);
    }
    onGetCmsContent() {
        this.getInstance().getCmsContent();
        this.setState(this.state.merge({
            loading: true
        }));
    }
    onGetCmsContentSuccess({ data }) {
        if (data.success) {
            this.setState(this.state.merge({
                loading: false,
                error: false,
                page: data.page
            }));
        }
        else {
            this.setState(this.state.merge({
                loading: false,
                error: true
            }));
        }
    }
    onGetCmsContentFailture() {
        this.setState(this.state.merge({
            loading: false,
            error: true
        }));
    }
    onValidateCode(code) {
        const pureCode = code.trim();
        this.trackEvent('validateCode', { interactionType: 'click' });
        this.getInstance().validateCode(pureCode);
        this.setState(this.state.merge({
            verifying: true,
            errorCode: null
        }));
    }
    onValidateCodeSuccess({ data }) {
        if (data.success) {
            const { offer, externalAuths, wallets, code, epicAccountName, connectedPlatforms, bonusOffers } = data;
            this.trackEvent('codeVerifySuccess');
            this.setState(this.state.merge({
                code,
                verifying: false,
                codeVerified: true,
                error: false,
                offer,
                externalAuths,
                wallets,
                epicAccountName,
                connectedPlatforms,
                bonusOffers
            }));
        }
        else {
            this.trackEvent('codeVerifySuccess', { errorCode: data.errorCode });
            this.setState(this.state.merge({
                code: null,
                verifying: false,
                codeVerified: false,
                error: true,
                errorCode: data.errorCode
            }));
        }
    }
    onValidateCodeFailure({ response }) {
        let errorCode = null;
        try {
            errorCode = response.data.errorCode || 'errors.com.epicgames.posa.unknown';
        }
        catch (ex) {
            errorCode = 'errors.com.epicgames.posa.unknown';
        }
        this.trackEvent('codeVerifyFailure', { errorCode });
        this.setState(this.state.merge({
            code: null,
            verifying: false,
            codeVerified: false,
            error: true,
            errorCode
        }));
    }
    onRedeemCode() {
        const { platform, code, psnRegion } = this.state;
        const pureCode = code.trim();
        const platformValue = index_1.getPlatformShortToLong(platform);
        const paylaod = {
            platform: platformValue
        };
        if (platformValue === 'PSN') {
            paylaod.platformRegion = psnRegion;
        }
        this.trackEvent('codeRedeemSuccess', { interactionType: 'click' });
        this.getInstance().redeemCode(pureCode, paylaod);
        this.setState(this.state.merge({
            loading: true,
            error: null,
            errorCode: null
        }));
    }
    onRedeemCodeSuccess({ data }) {
        if (data.success) {
            const { secondaryCode } = data;
            this.trackEvent('codeRedeemSuccess', { secondaryCodePlatform: secondaryCode && secondaryCode.platform });
            this.setState(this.state.merge({
                redeemed: true,
                loading: false,
                secondaryCode
            }));
        }
        else {
            this.trackEvent('codeRedeemFailure', { errorCode: 'unknown' });
            this.setState(this.state.merge({
                redeemed: false,
                loading: false
            }));
        }
    }
    onRedeemCodeFailure({ response }) {
        let errorCode = null;
        try {
            errorCode = response.data.errorCode || 'errors.com.epicgames.posa.unknown';
        }
        catch (ex) {
            errorCode = 'errors.com.epicgames.posa.unknown';
        }
        this.trackEvent('codeRedeemFailure', { errorCode });
        this.setState(this.state.merge({
            redeemed: false,
            errorCode,
            loading: false
        }));
    }
    // Called to clear error code when a valid code is entered.
    resetErrorCode() {
        this.setState(this.state.merge({
            errorCode: null
        }));
    }
    // Called when a player is starting flow over.
    resetFlow() {
        this.trackEvent('startOver', { interactionType: 'click', redeemed: this.state.redeemed });
        this.setState(this.state.merge({
            error: false,
            errorCode: null,
            code: null,
            codeVerified: false,
            verifying: false,
            platform: null,
            psnCountry: null,
            showConfirm: false,
            epicAccountName: null,
            redeemed: null
        }));
    }
    setPlatform(platform) {
        this.trackEvent('selectPlatform', { interactionType: 'click', platform });
        this.setState(this.state.merge({
            platform
        }));
    }
    setShowConfirm(showConfirm) {
        this.trackEvent(showConfirm ? 'showConfirmOverlay' : 'closeConfirmOverlay');
        this.setState(this.state.merge({
            showConfirm
        }));
    }
    setPsnCountry(country) {
        this.setState(this.state.merge({
            psnCountry: country,
            psnRegion: PsnContryRegionMapping_1.default[country]
        }));
    }
};
PosaRedeemStore = __decorate([
    decorators_1.datasource(PosaRedeemSource_1.default),
    epic_alt_utils_1.seamlessImmutable,
    __metadata("design:paramtypes", [])
], PosaRedeemStore);
exports.default = epic_react_common_1.alt.createStore(PosaRedeemStore, 'PosaRedeemStore');
//# sourceMappingURL=PosaRedeemStore.js.map